import { useTrackEventMutation } from 'app/data/mutations/use-track-event-mutation';
import { WebPageImpressionProperties, WebPageImpressionTrackEvent } from 'app/data/types/tracking';
import { useCallback } from 'react';

export const useTrackPageImpression = () => {
  const { trackEvent } = useTrackEventMutation();
  return useCallback(
    (properties: WebPageImpressionProperties) => {
      const eventPayload: WebPageImpressionTrackEvent = {
        type: 'impression',
        event_type: 'track_v2_web_page_impression',
        properties,
      };
      trackEvent(eventPayload);
    },
    [trackEvent],
  );
};
